export default /* glsl */ `
attribute vec2 reference;
uniform sampler2D curveTexture;
uniform float size;
uniform float width;
uniform float height;
uniform float zoom;
varying vec2 fragRef;
varying vec2 fragPos;

void main() {
  fragRef = reference.xy;
  vec4 curve = texture2D(curveTexture,reference.xy);
  fragPos = vec2(curve.x, -curve.y)+position.xy/size*2.0/zoom;
  gl_Position = projectionMatrix *  viewMatrix
    * vec4(fragPos.x, 1.0, fragPos.y, 1.);
}
`;
